import axios from "axios";
import Response from "../response";
import { errCodes } from "../response/errors";
import { BLITZ_CI_AUTH, COMMISSIONS_API_BASE_URL } from "../../utils/constants";

export const defaultUser = {
  id: "",
  orgID: "",
  firstName: "",
  lastName: "",
  email: "",
};

class Users {
  constructor() {
    this.baseUrl = COMMISSIONS_API_BASE_URL;
    this.endpoint = "data/users";
    this.url = `${this.baseUrl}/${this.endpoint}`;
    this.headers = {
      'Content-Type': 'application/json',
      'Authorization': '',
    };
  }

  #checkSession() {
    this.accessToken = sessionStorage.getItem(BLITZ_CI_AUTH);
    this.headers['Authorization'] = `Bearer ${this.accessToken}`;
  }

  async getUserData(userID) {
    this.#checkSession();
    try {
      const response = await axios.get(`${this.url}/${userID}`, { headers: this.headers });
      if (response.status === 200 && response.data.id) {
        return Response.create(response.data, true);
      }
      return Response.create({}, false, {}, errCodes.NotFound);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }

  async createUserData(userID, userData) {
    this.#checkSession();
    try {
      const response = await axios.post(`${this.url}/${userID}`, userData, { headers: this.headers });
      if (response.status === 201 && response.data.id) {
        return Response.create(response.data, true);
      }
      return Response.create({}, false, {}, errCodes.Internal);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }

  async verifyUserData(userID) {
    this.#checkSession();
    try {
      const response = await axios.get(`${this.url}/${userID}/verify`, { headers: this.headers });
      if (response.status === 200) {
        return Response.create({}, true);
      }
      return Response.create({}, false, {}, errCodes.Unauthorized);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }
}

export default Users;
